module.exports = __webpack_public_path__ + "img/indiv1.3c83032f.png";